import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_USER_ANNOUNCEMENT_REQUEST =
  'UserAnnouncement/FETCH_USER_ANNOUNCEMENT_REQUEST'
const FETCH_USER_ANNOUNCEMENT_SUCCESS =
  'UserAnnouncement/FETCH_USER_ANNOUNCEMENT_SUCCESS'
const FETCH_USER_ANNOUNCEMENT_FAILURE =
  'UserAnnouncement/FETCH_USER_ANNOUNCEMENT_FAILURE'

const FETCH_USER_ANNOUNCEMENT_BY_ID_REQUEST =
  'UserAnnouncement/FETCH_USER_ANNOUNCEMENT_BY_ID_REQUEST'
const FETCH_USER_ANNOUNCEMENT_BY_ID_SUCCESS =
  'UserAnnouncement/FETCH_USER_ANNOUNCEMENT_BY_ID_SUCCESS'
const FETCH_USER_ANNOUNCEMENT_BY_ID_FAILURE =
  'UserAnnouncement/FETCH_USER_ANNOUNCEMENT_BY_ID_FAILURE'

const DELETE_USER_ANNOUNCEMENT_REQUEST =
  'UserAnnouncement/DELETE_USER_ANNOUNCEMENT_REQUEST'
const DELETE_USER_ANNOUNCEMENT_SUCCESS =
  'UserAnnouncement/DELETE_USER_ANNOUNCEMENT_SUCCESS'
const DELETE_USER_ANNOUNCEMENT_FAILURE =
  'UserAnnouncement/DELETE_USER_ANNOUNCEMENT_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  userAnnouncementList: [],
  userAnnouncementObj: {}
}

// Default Reducer
const userAnnouncement = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_USER_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userAnnouncementList: action.payload
      }
    case FETCH_USER_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_USER_ANNOUNCEMENT_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_USER_ANNOUNCEMENT_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userAnnouncementObj: action.payload
      }
    case FETCH_USER_ANNOUNCEMENT_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_USER_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_USER_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_USER_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default userAnnouncement

// Action Creators
export const fetchUserAnnouncementList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_USER_ANNOUNCEMENT_REQUEST
      })

      const { data } = await API.get(EndPoints.USER_ANNOUNCEMENT)
      const dataResult = data.map((announcement) => {
        const materialList = announcement.announcementMaterialList
        const materialImgList = materialList.map(
          (material) => material.imageUrl
        )
        const binImgList = materialList.map(
          (material) => material.binImage
        )
        const resultList = {
          ...announcement.appUserAnnouncement,
          materialImgList: materialImgList,
          binImgList:binImgList,
          userName: announcement.userName
        }
        return resultList
      })
      dispatch({
        type: FETCH_USER_ANNOUNCEMENT_SUCCESS,
        payload: dataResult
      })
    } catch (err) {
      dispatch({
        type: FETCH_USER_ANNOUNCEMENT_FAILURE
      })
    }
  }
}

export const deleteUserAnnouncement = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_USER_ANNOUNCEMENT_REQUEST
      })
      await API.delete(EndPoints.USER_ANNOUNCEMENT + `/${id}`)
      dispatch({
        type: DELETE_USER_ANNOUNCEMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_USER_ANNOUNCEMENT_FAILURE
      })
    }
  }
}

export const fetchUserAnnouncementDetail = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_USER_ANNOUNCEMENT_BY_ID_REQUEST
      })

      const { data } = await API.get(
        EndPoints.USER_ANNOUNCEMENT + `/admin/${id}`
      )
      const heroOfferAdminList = data.heroOfferAdminList
      const interestedHero = heroOfferAdminList.filter(
        (hero) => hero.heroOfferStatusAdminDto.status !== 3
      )
      const notInterestedHero = heroOfferAdminList.filter(
        (hero) => hero.heroOfferStatusAdminDto.status === 3
      )
      const response = {
        ...data,
        interestedHero,
        notInterestedHero
      }
      dispatch({
        type: FETCH_USER_ANNOUNCEMENT_BY_ID_SUCCESS,
        payload: response
      })
    } catch (err) {
      dispatch({
        type: FETCH_USER_ANNOUNCEMENT_BY_ID_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/userAnnouncement.js